import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import searchReducer from './slices/search.slice';
import authReducer from './slices/auth';
import { localstore } from "../utils/localForageStorage";
import axiosInstance from "../utils/api";
import moment from 'moment';
import { jwtDecode } from 'jwt-decode';
import { getNewToken } from "./slices/auth/actions";
import hotTopicsReducer from './slices/hotTopics';

const createNoopStorage = () => {
  return {
    getItem() {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem() {
      return Promise.resolve();
    },
  };
};

const storage =
  typeof window !== "undefined"
    ? createWebStorage("local")
    : createNoopStorage();

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["userState","customerServiceState"],
};

const localStorageConfig = {
	key: 'root',
	storage: localstore,
};

const rootReducer = combineReducers({
  search: searchReducer,
  auth: persistReducer(localStorageConfig, authReducer),
  hotTopics: hotTopicsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});



//To set up axios instance after initialising store
const axiosInterceptor = (store) => {
	axiosInstance.interceptors.request.use(
		async (config) => {
			let user = store.getState().auth;
			if (user.token != null) {
				const decoded = jwtDecode(user.token);
				console.log('Token Expiration: ', moment.unix(decoded.exp).utcOffset(-5).format("YYYY-MM-DD hh:mm:ss A"));
				if (decoded.exp && decoded.exp - moment().unix() < 10) {
					await store.dispatch(getNewToken({ refreshToken: user.refreshToken }));
					user = store.getState().auth;
				}
				config.headers["Authorization"] = `Bearer ${user.token}`;
			}     
			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	//axiosInstance.interceptors.response.use(apiSuccessHandler, apiErrorHandler)
}

axiosInterceptor(store);